import React from 'react';
import { Tag, Space, Button } from 'antd';

interface DataListItemVO {
    text?: string,
    clickAction?: (rowItem: any) => void,
    tagText?: string,
    tagColor?: string,
    tagAction?: (rowItem: any) => void,
}

interface PropsType {
    dataList: DataListItemVO[]
}

const DisposeTableItem: React.FC<PropsType> = (props) => {
    const { dataList } = props;

    return (
        <Space direction={'vertical'}>
            {dataList?.filter(item => item.text || item.tagText)
                .map((item, index) => {
                return <div style={{ width: '100%', wordBreak: 'break-all' }} >
                    <Space>
                        {
                            item.clickAction ?
                                <a onClick={item.clickAction} >{item.text}</a> :
                                <span>{item.text}</span>
                        }
                        {
                            item.tagText ? <><Tag onClick={item.tagAction} color={item.tagColor || 'warning'}>{item.tagText}</Tag></> : null
                        }
                    </Space>
                </div>

            })}
        </Space>
    )
}

export default DisposeTableItem;


